import styled, { css } from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import { Box, Select, Button } from '../../atoms';
export const Form = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${themeGet('space.3')}px;
`;
export const Row = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: end;
  gap: 8px;
`;
export const Column = styled(Box)`
  display: flex;
  justify-content: end;
  flex: ${props => props.sizeFraction ? props.sizeFraction : '1'} 1 0;
  min-width: 170px;
`;
export const CustomSelect = styled(Select)`
  display: flex;
  width: 100%;
  select {
    border-radius: 12px;
    font-size: ${themeGet('fontSizes.1')}px;
    color: ${themeGet('colors.gray')};
    padding: 11px 16px;
  }

  select:disabled {
    cursor: not-allowed;
  }

  select option {
    color: black;
  }

  select:has(option:checked:not([value])),
  select:has(option:checked:not([value=''])) {
    color: black;
  }

  select:has(option:checked:not([value])) option,
  select:has(option:checked:not([value=''])) option {
    color: black;
  }
`;
export const CustomButton = styled(Button)`
  width: 100%;
  height: 40px;
  border-radius: 12px;
  padding: 12px 16px;
  ${({
  border
}) => !border && css`
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0);
    `}
`;